import { ExpandMore } from '@mui/icons-material';
import { useOcrQueue } from '@practium/features/analyses';
import { FloraAIIcon } from '@practium/ui';
import styles from './OcrQueueWidget.module.css';

export const OcrQueueNavbarButton = () => {
	const { items, isOpen, setIsOpen } = useOcrQueue();
	if (items.length === 0 || isOpen) return null;

	const finished = items.filter((item) => item.status === 'done').length;
	const isProcessing = items.some((item) =>
		['uploading', 'queued', 'processing'].includes(item.status)
	);

	return (
		<button
			className={styles.navbarButton}
			onClick={() => setIsOpen(true)}
			aria-label="Abrir fila de OCR"
		>
			<FloraAIIcon
				className={`${styles.navbarFlora} ${isProcessing ? styles.floraWorking : ''}`}
				aria-hidden="true"
			/>
			<span className={styles.progressCount}>
				{finished} de {items.length}
			</span>
			<ExpandMore />
		</button>
	);
};
